module.exports = (__webpack_require__(2))(24);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/ItemModel.js from dll-reference girder_plugin_slicer_cli_web
// module id = 34
// module chunks = 0